import { type RefObject, useEffect, useRef } from "react";
import { TbCircleCheck } from "react-icons/tb";
import { useParams } from "react-router-dom";
import { useResizeObserver } from "usehooks-ts";
import { Stepper } from "@/components/Stepper";
import {
  type SubmitPov,
  SubmitProvider,
  steps,
  useSubmit,
} from "@/submit/SubmitProvider";
import styles from "./PageSubmit.module.css";

export const IframePageSubmit = () => {
  const { token } = useParams();

  return <PageSubmit pov="customer" token={token ?? ""} />;
};

export const PageSubmit = (props: { pov: SubmitPov; token: string }) => {
  return (
    <SubmitProvider {...props}>
      <Content />
    </SubmitProvider>
  );
};

function Content() {
  const { Component, step, complete } = useSubmit();
  const containerRef = useRef<HTMLDivElement>(null);
  const { height } = useResizeObserver({
    ref: containerRef as RefObject<HTMLDivElement>,
    box: "border-box",
  });

  useEffect(() => {
    if (!height) {
      return;
    }

    // Send height to the parent, so it can adjust the iframe height
    window.parent.postMessage(height, "*");
  }, [height]);

  return (
    <div className={styles.container} ref={containerRef}>
      {!complete && <Stepper steps={steps} active={step} />}
      <div className={styles.content}>
        {complete ? (
          <div className={styles.complete}>
            <TbCircleCheck className={styles.completeIcon} />
            <h2>Thank you for your submission!</h2>
            <p>We will email you your options soon.</p>
          </div>
        ) : (
          <Component />
        )}
      </div>
    </div>
  );
}
